import { MESSAGES } from 'portal/src/constants/snackbarMessages';
import { ValidatorBody } from 'portal/src/validators/validateGuard';

export class ProjectFormValidators {
  getValues;

  constructor(getValues) {
    this.getValues = getValues;
  }

  /**
   * Return an array validator to guards control with validate function that return a single boolean
   * @returns {Array<ValidatorBody<boolean>>}
   */
  getFacilitiesValidator(): ValidatorBody<boolean | Promise<boolean>>[] {
    const values = this.getValues();
    return [
      {
        message: MESSAGES.FACILITY.ONE_REQUIRED,
        validate: () => !!values.facilities.length,
      },
    ];
  }
}
